export default __webpack_public_path__ + "static/media/Importador2BudgetForecast.0ca1b042.pdf";